import React from "react";

import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { clearProposal } from "../../actions/proposal";
import { closeModal } from "../../actions/ui";
import { images } from "../../constants";
import "./ProposalCreatedEditModal.scss";

const ProposalCreatedEditModal = ({ proposal }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { msgAlert } = useSelector((state) => state.alert);

  const handleContinueLink = () => {
    dispatch(clearProposal());
    dispatch(closeModal());
    setTimeout(() => {
      history.push("/creator/proposals");
    }, 1000);
  };

  return (
    <div className="proposal-created">
      <div className="proposal-created__wrapper">
        {msgAlert && (
          <div className="proposal-created__heading">
            <img src={images.IconSuccess} alt="" />
            <h3 className="title-gray-bold-26">{msgAlert.msg}</h3>
          </div>
        )}

        <div className="proposal-created__link">
          <h2 className="paragraph-gray-bold-16">
            Use the link below to open the proposal.
          </h2>
          <a
            href={`${proposal.link}`}
            target="_blank"
            rel="noopener noreferrer"
            className="link"
          >
            {proposal.link}
          </a>
        </div>

        <div className="proposal-created__continue">
          <button className="btn-primary" onClick={handleContinueLink}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProposalCreatedEditModal;
